import { IDropDownItem } from 'core/interface/dropDown';

export const Degrees: IDropDownItem[] = [
  { to_show: 'Certificate', value: 1 },
  { to_show: 'Bachelor', value: 2 },
  { to_show: 'Master', value: 3 },
  { to_show: 'phD', value: 4 }
];
